import src from "IMAGE";
export default { src, width: 255, height: 50, blurWidth: 0, blurHeight: 0};
